var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPropose1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    rx: 34,
    fill: "#292929"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4143 63.1701V37.879M40.4143 39.4597V48.9438M40.4143 39.4597C40.4143 36.1058 39.0344 32.8894 36.5782 30.5179C34.122 28.1464 30.7907 26.8141 27.3171 26.8141H17.4941V36.2983C17.4941 39.6521 18.874 42.8685 21.3302 45.24C23.7864 47.6115 27.1178 48.9438 30.5914 48.9438H40.4143M40.4143 39.4597H50.2372C53.7108 39.4597 57.0421 38.1274 59.4983 35.7558C61.9545 33.3843 63.3344 30.1679 63.3344 26.8141V17.3299H53.5115C50.0379 17.3299 46.7066 18.6622 44.2504 21.0337C41.7942 23.4052 40.4143 26.6216 40.4143 29.9755V39.4597ZM40.4143 39.4597L53.5115 26.8141M40.4143 48.9438L27.3171 36.2983",
    stroke: "url(#paint0_linear_3061_13050)",
    strokeWidth: 4.58403
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3061_13050",
    x1: 40.4143,
    y1: 17.3299,
    x2: 40.4143,
    y2: 63.1701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F42222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59331"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropose1);
export default __webpack_public_path__ + "static/media/propose1.17d53b57b17cd93ce89a7c01126acbb5.svg";
export { ForwardRef as ReactComponent };